import {GenericService} from '@/shared/xhttp';
import {Achat, Upload} from '@/models';

export class UploadService extends GenericService<Upload> {

	public postDocumentAchat(achat: Achat, upload: Upload): Promise<Upload> {
		return this.post(`/documentachats/${achat.id}`, upload);
	}
}
